import Resource from "./resource";
import ActionProperties from "client/resources/actionProperties";
import { OctopusReleaseFeedId } from "./feedResource";
import ParseHelper from "../../utils/ParseHelper/ParseHelper";
import * as _ from "lodash";

export class DeploymentActionResource extends Resource {
    Id: string;
    Name: string;
    ActionType: string;
    IsDisabled: boolean;
    CanBeUsedForProjectVersioning: boolean;
    Environments: string[];
    ExcludedEnvironments: string[];
    Channels: string[];
    TenantTags: string[];
    Properties: ActionProperties;
    IsRequired: boolean;
}

export default DeploymentActionResource;

export function IsPackageAction(action: DeploymentActionResource) {
    return !!action.Properties["Octopus.Action.Package.PackageId"];
}

export function IsDeployReleaseAction(action: DeploymentActionResource) {
    return !!action.Properties["Octopus.Action.DeployRelease.ProjectId"];
}

export function GetFeedId(action: DeploymentActionResource) {
    return IsDeployReleaseAction(action)
        ? OctopusReleaseFeedId
        : action.Properties["Octopus.Action.Package.FeedId"] as string;
}

export function HasManualInterventionResponsibleTeams(action: DeploymentActionResource) {
   return _.some(ParseHelper.parseCSV(action.Properties["Octopus.Action.Manual.ResponsibleTeamIds"] as string));
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/deploymentActionResource.ts